
import { Provider, Service, User } from "../types/model";

export const mockProviders: Provider[] = [
  {
    id: "1",
    name: "Salon Beauty & Style",
    branche: "friseur",
    adresse: "Hauptstraße 42, 10115 Berlin",
    standort: {
      latitude: 52.52,
      longitude: 13.405,
    },
    beschreibung: "Moderner Friseursalon mit Fokus auf nachhaltige Produkte und Trends.",
    zeiten: {
      Montag: { start: "09:00", end: "18:00" },
      Dienstag: { start: "09:00", end: "18:00" },
      Mittwoch: { start: "09:00", end: "18:00" },
      Donnerstag: { start: "09:00", end: "20:00" },
      Freitag: { start: "09:00", end: "18:00" },
      Samstag: { start: "10:00", end: "16:00" },
      Sonntag: { start: "", end: "" },
    },
    mitarbeiter: [],
    aktivierte_addons: ["bildupload", "fragebogen"],
    limit_buchungen: 50,
    branding: true,
    abo_status: "pro",
    imageUrl: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=500&q=80",
  },
  {
    id: "2",
    name: "Nail Art Studio",
    branche: "nagelstudio",
    adresse: "Friedrichstraße 123, 10117 Berlin",
    standort: {
      latitude: 52.51,
      longitude: 13.39,
    },
    beschreibung: "Spezialist für Nageldesign und Maniküre mit modernsten Techniken.",
    zeiten: {
      Montag: { start: "10:00", end: "19:00" },
      Dienstag: { start: "10:00", end: "19:00" },
      Mittwoch: { start: "10:00", end: "19:00" },
      Donnerstag: { start: "10:00", end: "19:00" },
      Freitag: { start: "10:00", end: "20:00" },
      Samstag: { start: "10:00", end: "18:00" },
      Sonntag: { start: "", end: "" },
    },
    mitarbeiter: [],
    aktivierte_addons: ["bildupload"],
    limit_buchungen: 30,
    branding: true,
    abo_status: "starter",
    imageUrl: "https://images.unsplash.com/photo-1610992015742-4b92fb2f03c1?w=500&q=80",
  },
  {
    id: "3",
    name: "Life Coach Berlin",
    branche: "coaching",
    adresse: "Bergmannstraße 78, 10961 Berlin",
    standort: {
      latitude: 52.49,
      longitude: 13.41,
    },
    beschreibung: "Persönliches und Business Coaching für mehr Erfolg und Zufriedenheit.",
    zeiten: {
      Montag: { start: "09:00", end: "17:00" },
      Dienstag: { start: "09:00", end: "17:00" },
      Mittwoch: { start: "09:00", end: "17:00" },
      Donnerstag: { start: "09:00", end: "17:00" },
      Freitag: { start: "09:00", end: "15:00" },
      Samstag: { start: "", end: "" },
      Sonntag: { start: "", end: "" },
    },
    mitarbeiter: [],
    aktivierte_addons: ["fragebogen", "chat"],
    limit_buchungen: 20,
    branding: false,
    abo_status: "premium",
    imageUrl: "https://images.unsplash.com/photo-1565728744382-61accd4aa148?w=500&q=80",
  },
  {
    id: "4",
    name: "Wellness Spa",
    branche: "massage",
    adresse: "Potsdamer Platz 5, 10785 Berlin",
    standort: {
      latitude: 52.51,
      longitude: 13.37,
    },
    beschreibung: "Entspannende Massagen und Wellness-Behandlungen in luxuriösem Ambiente.",
    zeiten: {
      Montag: { start: "11:00", end: "20:00" },
      Dienstag: { start: "11:00", end: "20:00" },
      Mittwoch: { start: "11:00", end: "20:00" },
      Donnerstag: { start: "11:00", end: "20:00" },
      Freitag: { start: "11:00", end: "21:00" },
      Samstag: { start: "10:00", end: "21:00" },
      Sonntag: { start: "12:00", end: "18:00" },
    },
    mitarbeiter: [],
    aktivierte_addons: ["fragebogen"],
    limit_buchungen: 40,
    branding: true,
    abo_status: "pro",
    imageUrl: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=500&q=80",
  }
];

export const mockServices: Record<string, Service[]> = {
  "1": [
    {
      id: "101",
      name: "Damen Haarschnitt",
      dauer: 45,
      preis: 39.90,
      beschreibung: "Kompletter Haarschnitt inkl. Beratung, Waschen und Föhnen",
      kategorie: "Haarschnitt",
      addons_aktiv: ["bildupload", "fragebogen"],
      dienstleister: mockProviders[0],
    },
    {
      id: "102",
      name: "Herren Haarschnitt",
      dauer: 30,
      preis: 29.90,
      beschreibung: "Haarschnitt für Herren inkl. Waschen",
      kategorie: "Haarschnitt",
      addons_aktiv: ["bildupload"],
      dienstleister: mockProviders[0],
    },
    {
      id: "103",
      name: "Haarfarbe",
      dauer: 90,
      preis: 69.90,
      beschreibung: "Komplette Coloration inkl. Beratung und Pflege",
      kategorie: "Coloration",
      addons_aktiv: ["bildupload", "fragebogen"],
      dienstleister: mockProviders[0],
    }
  ],
  "2": [
    {
      id: "201",
      name: "Maniküre",
      dauer: 30,
      preis: 29.90,
      beschreibung: "Klassische Maniküre inkl. Handpeeling und Massage",
      kategorie: "Maniküre",
      addons_aktiv: ["bildupload"],
      dienstleister: mockProviders[1],
    },
    {
      id: "202",
      name: "Shellac Nägel",
      dauer: 60,
      preis: 49.90,
      beschreibung: "Langanhaltender Nagellack mit UV-Aushärtung",
      kategorie: "Nägel",
      addons_aktiv: ["bildupload"],
      dienstleister: mockProviders[1],
    }
  ],
  "3": [
    {
      id: "301",
      name: "Karriere-Coaching",
      dauer: 60,
      preis: 89.90,
      beschreibung: "Strategische Beratung für berufliche Ziele",
      kategorie: "Coaching",
      addons_aktiv: ["fragebogen"],
      dienstleister: mockProviders[2],
    },
    {
      id: "302",
      name: "Life-Balance Coaching",
      dauer: 90,
      preis: 119.90,
      beschreibung: "Ganzheitliches Coaching für mehr Balance im Leben",
      kategorie: "Coaching",
      addons_aktiv: ["fragebogen", "chat"],
      dienstleister: mockProviders[2],
    }
  ],
  "4": [
    {
      id: "401",
      name: "Klassische Massage",
      dauer: 60,
      preis: 69.90,
      beschreibung: "Entspannende Ganzkörpermassage",
      kategorie: "Massage",
      addons_aktiv: ["fragebogen"],
      dienstleister: mockProviders[3],
    },
    {
      id: "402",
      name: "Hot Stone Massage",
      dauer: 75,
      preis: 89.90,
      beschreibung: "Tiefenwirksame Massage mit warmen Basaltsteinen",
      kategorie: "Massage",
      addons_aktiv: ["fragebogen"],
      dienstleister: mockProviders[3],
    }
  ]
};

export const mockCategories = [
  { id: "friseur", name: "Friseur" },
  { id: "nagelstudio", name: "Nagelstudio" },
  { id: "kosmetik", name: "Kosmetik" },
  { id: "coaching", name: "Coaching" },
  { id: "massage", name: "Massage" },
  { id: "tattoo", name: "Tattoo" },
];

// Helper function to get available time slots
export const getAvailableTimeSlots = (date: Date, providerId: string): string[] => {
  const provider = mockProviders.find(p => p.id === providerId);
  
  if (!provider) return [];
  
  const dayOfWeek = new Intl.DateTimeFormat('de-DE', { weekday: 'long' }).format(date);
  const daySchedule = provider.zeiten[dayOfWeek];
  
  if (!daySchedule || !daySchedule.start || !daySchedule.end) return [];
  
  const startHour = parseInt(daySchedule.start.split(':')[0]);
  const endHour = parseInt(daySchedule.end.split(':')[0]);
  
  const slots: string[] = [];
  
  for (let hour = startHour; hour < endHour; hour++) {
    slots.push(`${hour.toString().padStart(2, '0')}:00`);
    if (hour < endHour - 1) {
      slots.push(`${hour.toString().padStart(2, '0')}:30`);
    }
  }
  
  return slots;
};
